module.exports = __webpack_public_path__ + "static/img/4645_phase_function_Paper_PointsHejduk_Prediction.8f2178f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4645_phase_function_Paper_PointsHejduk_Prediction.png
// module id = ybn8
// module chunks = 0